import React from 'react';

// Routes
import Routes from './general-all-routes';

export default function (props) {

  
  return (
   <div>
       <Routes />
   </div>
  )
}
